export const environment = {
  production: false,
  enableLogging: false,
  enableSSL: true,
  // API calls use relative paths so they stay same-origin, which serves two cases:
  //  - Deployed: the host front-door nginx on 443 routes each path to the backend.
  //  - Local (npm run start:int1): the ng-serve proxy (proxy.int1.conf.json)
  //    forwards those paths to int1.loqt.app, avoiding CORS from localhost:4200.
  useProxy: true,
  apiHostname: "int1.loqt.app",
  awsS3BucketURL: "https://digis3bucketsample.s3.eu-west-2.amazonaws.com",
  httpsCertificateName: "SSL_COM_RSA_SSL_SUBCA.cer",
  services: {} as Record<string, number>,
};
